// extracted by mini-css-extract-plugin
export default {"rating":"rating_rating__i9Spo","rating-star":"rating_rating-star__nwj2O"};